<div style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
    padding-top: 200px;">
    <div *ngIf="error" style="height: 100%;margin: 0;display: flex;justify-content: center;align-items: center;">
        <div style="display: flex;justify-content: center;align-items: center;height: 100%;width: 100%;position: fixed;top: 0;left: 0;">
            <div style="background-color: #f8d7da;color: #721c24;padding: 20px;border: 1px solid #f5c6cb;border-radius: 5px;text-align: center;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);">
                Invalid credentials. Please contact administrator for more details or login manually with username and password.
                <br /><br /><br />
                <p-button label="Login" [routerLink]="['/login']" styleClass="pink-btn"></p-button>
            </div>
        </div>
    </div>
</div>
